import React, { useEffect, useState } from "react";
import { api } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";

// Sélecteur d'amis — extrait de Create.tsx (où il vivait en local, non exporté) pour être
// réutilisé par le Jardin Secret (inviter dans "Notre Jardin", choisir les "Personnes choisies"
// d'un élément). Miroir du composant déjà extrait côté mobile (components/create/FriendSelector.tsx).
export default function FriendSelector({ selected, onToggle, excludeIds }: { selected: string[]; onToggle: (id: string) => void; excludeIds?: string[] }) {
  const { user, lang } = useApp();
  const [friends, setFriends] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) return;
    api.get(`/users/${user.id}/friends`)
      .then(data => setFriends(data?.friends || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user?.id]);

  if (loading) return <div style={{ fontSize: 13, color: "#999", padding: "8px 0", marginBottom: 16 }}>{t(lang, "cr_loading_friends")}</div>;
  const visible = excludeIds ? friends.filter(f => !excludeIds.includes(f.id)) : friends;
  if (visible.length === 0) return <div style={{ fontSize: 13, color: "#999", padding: "8px 0", marginBottom: 16 }}>{t(lang, "cr_no_friends_invite")}</div>;

  return (
    <div style={{ display: "flex", gap: 12, overflowX: "auto", padding: "8px 0", marginBottom: 16 }}>
      {visible.map(friend => (
        <div key={friend.id} onClick={() => onToggle(friend.id)} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, cursor: "pointer", flexShrink: 0 }}>
          <div style={{ width: 48, height: 48, borderRadius: "50%", position: "relative", border: selected.includes(friend.id) ? "3px solid #0a0a0a" : "3px solid transparent" }}>
            <div style={{ width: "100%", height: "100%", borderRadius: "50%", overflow: "hidden", backgroundColor: "#0a0a0a", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontWeight: 700, fontSize: 13 }}>
              {friend.avatar_url ? <img src={friend.avatar_url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : (friend.name || "?").split(" ").map((n: string) => n[0]).join("").slice(0, 2).toUpperCase()}
            </div>
            {selected.includes(friend.id) && <div style={{ position: "absolute", bottom: -2, right: -2, width: 16, height: 16, borderRadius: "50%", backgroundColor: "#0a0a0a", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center" }}><span style={{ color: "white", fontSize: 9 }}>✓</span></div>}
          </div>
          <span style={{ fontSize: 10, color: selected.includes(friend.id) ? "#0a0a0a" : "#999", fontWeight: selected.includes(friend.id) ? 600 : 400 }}>{(friend.name || "?").split(" ")[0]}</span>
        </div>
      ))}
    </div>
  );
}
